import ApiService from './api';

export const ReceiptService = {
  /**
   * Send e-receipt via SMS
   * @param {string} orderId - The order ID to send receipt for
   * @returns {Promise} Response with receipt URL and send status
   */
  sendEReceipt: async (orderId) => {
    try {
      const response = await ApiService.post('/order-receipts/send-receipt', {
        orderId
      });
      console.log('✅ E-Receipt sent:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error sending e-receipt:', error.response?.data || error.message);
      throw error;
    }
  }
};

export default ReceiptService;
